<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/announcements/toevoegen')" class="pull-right"
                      v-can="'mededelingen aanpassen'">Mededeling toevoegen
            </b-button>
          </b-col>
        </b-row>
        <resource-index header="Mededelingen" endpoint="announcements" show-route="announcements.view"/>
      </div>
    </div>
  </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'announcements',
        components: {ResourceIndex},
    }
</script>
